export enum RouteEnum {
    CHOICE_SELECTION = "/choice-selection",
    LEAVE_INFORMATION = "/leave-information",
    THANK_YOU = "/thank-you",
    TERMS_AND_CONDITIONS = "/terms-and-conditions",
}
